// src/pages/common/reports/R0006/utils/clientConfigUtils.js

/**
 * Utility functions to load client-specific configurations
 * These functions attempt to load client configs and fall back to defaults
 */

export const getClientKPIConfig = () => {
  try {
    // Try to dynamically import client-specific KPI config
    // This would be determined by current client context
    const currentClient = getCurrentClient(); // You'd implement this
    
    if (currentClient === 'grm') {
      // Dynamic import for GRM client
      const { grmKPIConfig } = require(`pages/clients/grm/reports/R0006/configs/KPICard.config`);
      return grmKPIConfig;
    }
    
    // Add other clients as needed
    // if (currentClient === 'otherClient') { ... }
    
    // Fall back to default config
    return getDefaultKPIConfig();
  } catch (error) {
    console.warn('Failed to load client KPI config, using defaults:', error);
    return getDefaultKPIConfig();
  }
};

export const getClientBusinessRules = () => {
  try {
    const currentClient = getCurrentClient();
    
    if (currentClient === 'grm') {
      const { grmBusinessRules } = require(`pages/clients/grm/reports/R0006/configs/businessRules.config`);
      return grmBusinessRules;
    }
    
    return null; // Will use defaults from constants
  } catch (error) {
    console.warn('Failed to load client business rules, using defaults:', error);
    return null;
  }
};

export const getClientTableConfig = () => {
  try {
    const currentClient = getCurrentClient();
    
    if (currentClient === 'grm') {
      const { grmTableConfig } = require(`pages/clients/grm/reports/R0006/configs/tables.config`);
      return grmTableConfig;
    }
    
    return getDefaultTableConfig();
  } catch (error) {
    console.warn('Failed to load client table config, using defaults:', error);
    return getDefaultTableConfig();
  }
};

// Helper function to get current client - you'd implement this based on your routing/context
const getCurrentClient = () => {
  // This would get the current client from URL, context, or some other method
  // For now, return a default
  return 'grm'; // or extract from window.location.pathname, etc.
};

const getDefaultKPIConfig = () => {
  // Return default KPI configuration
  return {
    themes: {
      totalSales: { iconColor: '#2196f3' },
      performance: { iconColor: '#4caf50' },
      opportunity: { iconColor: '#ff9800' }
    },
    ratings: {
      performance: {
        excellent: { min: 90, color: '#2196f3' },
        good: { min: 75, color: '#4caf50' },
        fair: { min: 50, color: '#ff9800' },
        poor: { min: 0, color: '#f44336' }
      },
      opportunity: {
        ranges: [
          { min: 0,   max: 3.9, color: '#ffffff', bgColor: '#4caf50', label: 'Optimized' },
          { min: 4,   max: 10,  color: '#000000', bgColor: '#ff9800', label: 'Moderate' },
          { min: 10.1, max: 100, color: '#ffffff', bgColor: '#f44336', label: 'High Priority' }
        ]
      }
    }
  };
};

const getDefaultTableConfig = () => {
  // Return default table configuration
  return {
    salesPerformance: {
      columns: [
        { key: 'restaurant', label: 'Restaurant' },
        { key: 'projection', label: 'Projection' },
        { key: 'actual', label: 'Actual' },
        { key: 'variance', label: 'Variance' }
      ]
    },
    laborHours: {
      columns: [
        { key: 'restaurant', label: 'Restaurant' },
        { key: 'fohScheduled', label: 'FOH Scheduled' },
        { key: 'bohScheduled', label: 'BOH Scheduled' }
      ]
    }
  };
};